<ngx-signature-pad (drawStart)="onStartSigning()" (drawEnd)="onEndSigning()" [ngClass]="{ disabled: disabled }"></ngx-signature-pad>

@if (label) {
  <mat-label class="signature-label" [ngClass]="{ disabled: disabled }">{{ label }}</mat-label>
}
@if (touched && !isValid) {
  <mat-error>
    @for (err of errors; track err) {
      {{ err | translate }}
    }
  </mat-error>
}
@if (showClearButton) {
  <button mat-raised-button [disabled]="isEmpty || disabled" class="clear-button" (click)="clear()">
    {{ 'Clear' | translate }}
  </button>
}